import http from '../../../http/http';
import router from '../../../router';

const state = {
    trains: [],
    selectedTrains: [],
    artItems: [],
    artDetails: [],
    artTrains: [],
    artTrainsTxt: '',
    searchItems: {
        artnum: '',
        tags: '',
        foto: false,
        stao: ''
    },
    searchTrains: [],
    lagerCheff: []
};

const getters = {
    trains: (state) => state.trains,
    selectedTrains: (state) => state.selectedTrains,
    artItems: (state) => state.artItems,
    artDetails: (state) => state.artDetails,
    artTrains: (state) => state.artTrains,
    artTrainsTxt: (state) => state.artTrainsTxt,
    searchItems: (state) => state.searchItems,
    searchTrains: (state) => state.searchTrains,
    lagerCheff: (state) => state.lagerCheff

};

const mutations = {
    trains: (state, payload) => {
        state.trains = payload;
    },
    selectedTrains: (state, payload) => {
        state.selectedTrains = payload;
    },
    artItems: (state, payload) => {
        state.artItems = payload;
    },
    artDetails: (state, payload) => {
        state.artDetails = payload;
    },
    artTrains: (state, payload) => {
        state.artTrains = payload;
    },
    artTrainsTxt: (state, payload) => {
        state.artTrainsTxt = payload;
    },
    searchItems: (state, payload) => {
        state.searchItems = payload;
    },
    searchTrains: (state, payload) => {
        state.searchTrains = payload;
    },
    lagerCheff: (state, payload) => {
        state.lagerCheff = payload;
    }
};

const actions = {
    trains: ({ commit }, payload) => {
        http.get('/allTrains')
            .then((response) => {
                commit('trains', response.data);
            });
    },

    selectedTrains: ({ commit }, payload) => {
        commit('selectedTrains', payload);
        router.go(-1);
    },

    delSelectedTrains: ({ commit }, payload) => {
        commit('selectedTrains', []);
    },

    saveSearchTrains: ({ commit, state }) => {
        const data = [];

        for (let i = 0; i < state.selectedTrains.length; i++) {
            data.push({ id: state.selectedTrains[i].id, train: state.selectedTrains[i].train });
        }

        commit('searchTrains', data);
    },

    loadSearchTrains: ({ commit, state }) => {
        const data = [];

        for (let i = 0; i < state.searchTrains.length; i++) {
            data.push({ id: state.searchTrains[i].id, train: state.searchTrains[i].train });
        }

        commit('selectedTrains', data);
    },

    search: ({ commit, dispatch, state }, filterObject) => {
        const trains = [];
        let tags = '';

        commit('searchItems', {
            artnum: filterObject.artnum,
            tags: filterObject.tags,
            foto: filterObject.foto,
            stao: filterObject.stao
        });

        // check if artnum is correct formate
        // if(payload.artnum != '' && payload.artnum.match(/^([0-9aA\-\*]+)$/) == null){
        //
        //     // push the msg to the notifications
        //     dispatch('notifications/notification',{
        //         msg:'Falsches artikel nummer Format',
        //         error:true,
        //         time:800
        //     },{root:true});
        //
        //     return 0;
        // }

        // we only need the train ids
        if (state.selectedTrains[0] != null) {
            for (let i = 0; i < state.selectedTrains.length; i++) {
                trains.push(state.selectedTrains[i].id);
            }
        }

        // change the artnum * to %
        filterObject.artnum = filterObject.artnum.replace(/\*/g, '%');

        if (filterObject.tags !== '') {
            // change the \n to ' '
            filterObject.tags = filterObject.tags.replace(/\n/g, ' ');
            // remove multiple spaces
            filterObject.tags = filterObject.tags.replace(/ {2,}/g, ' ');
            // add the % to beginning and end of word
            filterObject.tags = '%' + filterObject.tags.replace(/ /g, '% %') + '%';
            // change the tags into an array
            tags = filterObject.tags.split(' ');
        }

        // only do this if there is only a artnum
        if (filterObject.artnum !== '' && state.selectedTrains[0] == null && filterObject.tags === '') {
            console.log('just artnum');

            const data = {
                artnum: filterObject.artnum,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            // post the search data
            http.post('/justArtnum', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }

        // only do this if there are just tags
        if (filterObject.artnum === '' && state.selectedTrains[0] == null && filterObject.tags !== '') {
            const data = {
                tags: tags,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            http.post('/justTags', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }

        // only do this if there are just trains
        if (filterObject.artnum === '' && state.selectedTrains[0] != null && filterObject.tags === '') {
            console.log('just trains');

            const data = {
                trains: trains,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            http.post('/justTrains', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }

        // only do this if there is an artnum and tags
        if (filterObject.artnum !== '' && state.selectedTrains[0] == null && filterObject.tags !== '') {
            console.log('artnum and tags');

            const data = {
                artnum: filterObject.artnum,
                tags: tags,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            http.post('/artnumAndTags', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }

        // only do this if there is an artnum and trains
        if (filterObject.artnum !== '' && state.selectedTrains[0] != null && filterObject.tags === '') {
            const data = {
                artnum: filterObject.artnum,
                trains: trains,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            http.post('/artnumAndTrains', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }

        // only do this if there is an tags and trains
        if (filterObject.artnum === '' && state.selectedTrains[0] != null && filterObject.tags !== '') {
            const data = {
                tags: tags,
                trains: trains,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            http.post('/tagsAndTrains', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }

        // only do this if there are all three
        if (filterObject.artnum !== '' && state.selectedTrains[0] != null && filterObject.tags !== '') {
            const data = {
                tags: tags,
                trains: trains,
                artnum: filterObject.artnum,
                foto: filterObject.foto,
                stao: filterObject.stao
            };

            http.post('/tagsTrainsAndArtnum', data)
                .then((response) => {
                    commit('artItems', response.data);
                    router.push('/fotodatenbank');
                });
        }
    },

    openDetails: ({ commit }, payload) => {
        const data = { id: payload.id, stao: payload.stao };

        let trains = '';

        // post the search data
        http.post('/artFromId', data)
            .then((response) => {
                if (response.data.trains.length > 0) {
                    let i = 0;

                    for (; i < response.data.trains.length - 1; i++) {
                        trains = trains + response.data.trains[i].train + ',   ';
                    }

                    trains = trains + response.data.trains[i].train;
                }

                http.post('/getLagerStuff', data)
                    .then((lager) => {
                        if (lager.data[0]) {
                            response.data.art[0].ort = lager.data[0].lagerOrt;
                            response.data.art[0].min = lager.data[0].besMin;
                            response.data.art[0].max = lager.data[0].besMax;
                            response.data.art[0].bestell = lager.data[0].bestell;
                            response.data.art[0].kapa = lager.data[0].capacity;
                            response.data.art[0].notiz = lager.data[0].notiz;
                            response.data.art[0].verbrauchsMat = lager.data[0].verbrauchsMat;
                            response.data.art[0].sfs = lager.data[0].sfs;
                            response.data.art[0].em = lager.data[0].em;
                            response.data.art[0].packung = lager.data[0].packung;
                            response.data.art[0].kuechenmat = lager.data[0].kuechenmat;
                            response.data.art[0].primaer = lager.data[0].primaer;
                            response.data.art[0].sekundaer = lager.data[0].sekundaer;
                        } else {
                            response.data.art[0].ort = '';
                            response.data.art[0].min = '';
                            response.data.art[0].max = '';
                            response.data.art[0].bestell = '';
                            response.data.art[0].kapa = '';
                            response.data.art[0].notiz = '';
                            response.data.art[0].packung = 0;
                            response.data.art[0].verbrauchsMat = 0;
                            response.data.art[0].sfs = 0;
                            response.data.art[0].em = 0;
                            response.data.art[0].kuechenmat = 0;
                            response.data.art[0].primaer = 0;
                            response.data.art[0].sekundaer = 0;
                        }

                        if (response.data.art[0].notiz == null) {
                            response.data.art[0].notiz = '';
                        }

                        http.post('/getLagerOtherStao', { artId: data.id, staoId: data.stao })
                            .then((otherlager) => {
                                response.data.art[0].otherLager = otherlager.data;

                                if (otherlager.data.length <= 0) {
                                    response.data.art[0].otherLager = '';
                                }

                                // console.log(response.data.art[0]);

                                commit('artDetails', response.data.art[0]);
                                commit('artTrains', response.data.trains);
                                commit('artTrainsTxt', trains);

                                if (payload.switch) {
                                    commit('selectedTrains', response.data.trains)
                                }
                            });
                    });
            });
    },

    openDetailsArtNum: ({ commit }, payload) => {
        const data = { artnum: payload.artnum, stao: payload.stao };

        let trains = '';

        // post the search data
        http.post('/artFromArt', data)
            .then((response) => {
                if (response.data.trains.length > 0) {
                    let i = 0;

                    for (; i < response.data.trains.length - 1; i++) {
                        trains = trains + response.data.trains[i].train + ',   ';
                    }

                    trains = trains + response.data.trains[i].train;
                }

                http.post('/getLagerStuff', data)
                    .then((lager) => {
                        console.log(lager.data);

                        if (lager.data[0]) {
                            response.data.art[0].ort = lager.data[0].lagerOrt;
                            response.data.art[0].min = lager.data[0].besMin;
                            response.data.art[0].max = lager.data[0].besMax;
                            response.data.art[0].bestell = lager.data[0].bestell;
                        } else {
                            response.data.art[0].ort = '';
                            response.data.art[0].min = '';
                            response.data.art[0].max = '';
                            response.data.art[0].bestell = '';
                        }

                        commit('artDetails', response.data.art[0]);
                        commit('artTrains', response.data.trains);
                        commit('artTrainsTxt', trains);

                        if (payload.switch) {
                            commit('selectedTrains', response.data.trains)
                        }
                    });
            });
    },

    abbuchen: ({ commit, state }, payload) => {
        // if you want to stornieren then the mult is -1. els it is 1.
        payload.amount = payload.amount * payload.mult;

        if (state.artDetails.max - payload.amount > 0) {
            state.artDetails.max = state.artDetails.max - payload.amount;
        } else {
            state.artDetails.max = 0;
        }

        const data = {
            bes: state.artDetails.max,
            stao: payload.stao,
            id: payload.id
        };

        console.log(data);

        http.post('/updateLagerFromId', data)
            .then((response) => {
                router.go(-1);
            });
    },

    changeArt: ({ commit }, payload) => {
        let trains = [];

        // we only need the train ids
        if (state.selectedTrains[0] != null) {
            for (let i = 0; i < state.selectedTrains.length; i++) {
                trains.push(state.selectedTrains[i].id);
            }
        }

        // mysql likes this better
        if (payload.min === '') {
            payload.min = 0;
        }
        if (payload.bes === '') {
            payload.bes = 0;
        }
        if (payload.bestell === '') {
            payload.bestell = 0;
        }
        // the capacity of the lager cannot be less the the minimum they have to have.
        if (payload.kapa === '') {
            payload.kapa = payload.min;
        }
        if (payload.StkProEinheit === '') {
            payload.StkProEinheit = 1;
        }
        if (payload.packung) {
            payload.packung = 1;
        } else {
            payload.packung = 0;
        }

        const data = {
            id: payload.id,
            artnum: payload.artnum,
            info: payload.info,
            shorttxt: payload.shorttxt,
            notiz: payload.notiz,
            verbrauchsMat: payload.verbrauchsMat,
            sfs: payload.sfs,
            em: payload.em,
            kuechenmat: payload.kuechenmat,
            primaer: payload.primaer,
            sekundaer: payload.sekundaer,
            ort: payload.ort,
            stao: payload.stao,
            min: payload.min,
            bes: payload.max,
            kapa: payload.kapa,
            // bestell:payload.bestell,
            mengeneinheit: payload.mengeneinheit,
            StkProEinheit: payload.StkProEinheit,
            packung: payload.packung,
            MHD: payload.MHD,
            greater100: payload.greater100,
            trains: trains
        };

        http.post('/updateArt', data)
            .then((response) => {
                // post the search data
                http.post('/artFromId', { id: payload.id })
                    .then((response) => {
                        if (response.data.trains.length > 0) {
                            let i = 0;

                            for (; i < response.data.trains.length - 1; i++) {
                                trains = trains + response.data.trains[i].train + ',   ';
                            }

                            trains = trains + response.data.trains[i].train;
                        }

                        http.post('/getLagerStuff', data)
                            .then((lager) => {
                                if (lager.data[0]) {
                                    response.data.art[0].ort = lager.data[0].lagerOrt;
                                    response.data.art[0].min = lager.data[0].besMin;
                                    response.data.art[0].max = lager.data[0].besMax;
                                    response.data.art[0].bestell = lager.data[0].bestell;
                                    response.data.art[0].kapa = lager.data[0].capacity;
                                    response.data.art[0].notiz = lager.data[0].notiz;
                                } else {
                                    response.data.art[0].ort = '';
                                    response.data.art[0].min = '';
                                    response.data.art[0].max = '';
                                    response.data.art[0].bestell = '';
                                    response.data.art[0].kapa = '';
                                    response.data.art[0].notiz = '';
                                }

                                if (response.data.art[0].notiz == null) {
                                    response.data.art[0].notiz = '';
                                }

                                http.post('/getLagerOtherStao', { artId: data.id, staoId: data.stao })
                                    .then((otherlager) => {
                                        response.data.art[0].otherLager = otherlager.data;

                                        if (otherlager.data.length <= 0) {
                                            response.data.art[0].otherLager = '';
                                        }

                                        commit('artDetails', response.data.art[0]);
                                        commit('artTrains', response.data.trains);
                                        commit('artTrainsTxt', trains);

                                        router.go(-1);
                                    });
                            });
                        // commit('artDetails', response.data.art[0]);
                        // commit('artTrains', response.data.trains);
                        // commit('artTrainsTxt', trains);

                        // router.go(-1)
                    });
            });
    },

    uploadImg: ({ commit, dispatch }, payload) => {
        let trains = [];

        // make sure file size isn't too big
        if (payload.img.size > 2000000) {
            // push the msg to the notifications
            dispatch('notifications/notification', {
                msg: 'Foto zu gross. Bitte unter 2.0Mb halten.',
                error: true,
                time: 5000
            }, { root: true });
        } else {
            const ext = payload.img.name.split('.');
            const filename = payload.id + '.' + ext[ext.length - 1].toUpperCase();

            console.log(payload.img.size);

            const data = new FormData();

            data.append('image', payload.img, filename);
            data.append('id', payload.id);
            data.append('artnum', payload.artnum);

            http.post('/uploadImg', data)
                .then((response) => {
                    console.log(response);
                    // post the search data
                    http.post('/artFromId', data)
                        .then((response) => {
                            if (response.data.trains.length > 0) {
                                let i = 0;

                                for (; i < response.data.trains.length - 1; i++) {
                                    trains = trains + response.data.trains[i].train + ',   ';
                                }

                                trains = trains + response.data.trains[i].train;
                            }

                            commit('artDetails', response.data.art[0]);
                            commit('artTrains', response.data.trains);
                            commit('artTrainsTxt', trains);
                        });
                });
        }
    },

    addArt: ({ commit, dispatch }, payload) => {
        const data = {
            artnum: payload.artnum
        };

        http.post('/addArt', data)
            .then((response) => {
                console.log(response.data.insertId);

                // // post the search data
                // http.post('/artFromId',{id:response.data.insertId})
                //     .then((response)=>{

                //         const trains = [];

                //         if(response.data.trains.length > 0){

                //             for(const i=0; i<response.data.trains.length-1;i++){

                //                 trains = trains + response.data.trains[i].train +',   ';

                //             }

                //             trains = trains + response.data.trains[i].train;

                //         }

                //         commit('artDetails', response.data.art[0]);
                //         commit('artTrains', response.data.trains);
                //         commit('artTrainsTxt', trains);

                //         router.push('/fotodatenbank/editart/'+response.data.insertId);
                // });

                router.push('/fotodatenbank/artdetails/' + response.data.insertId + '/' + payload.stao + '/editart');
            });
    },

    delArt: ({}, payload) => {
        const data = {
            pw: payload,
            id: state.artDetails.id
        };

        http.post('/delArt', data)
            .then((response) => {
                router.push({ name: 'fotodatenbank' })
            });
    },

    getAllTrainsWithFav: ({ commit, state }) => {
        http.get('/getAllTrainsWithFav')
            .then((response) => {
                const array = [];
                let selected = false;

                for (let i = 0; i < response.data.length; i++) {
                    selected = false;

                    for (let q = 0; q < state.selectedTrains.length; q++) {
                        if (response.data[i].id === state.selectedTrains[q].id) {
                            selected = true;
                        }
                    }

                    const data = {
                        id: response.data[i].id,
                        train: response.data[i].train,
                        hidden: false,
                        selected: selected
                    };

                    array.push(data);
                }

                commit('trains', array);
            });
    },

    getLagerCheff: ({ commit }, payload) => {
        http.post('/getLagerCheff', payload)
            .then((response) => {
                commit('lagerCheff', response.data);
            });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
